exports.buildContentfulLink = (contentfulId, spaceId, environment) => {
  if (!contentfulId || !spaceId || !environment) return;
  return `https://app.contentful.com/spaces/${spaceId}/environments/${environment}/entries/${contentfulId}`;
};
